// extracted by mini-css-extract-plugin
export var item = "fc-2-column-image-module--item--70ba4";
export var root = "fc-2-column-image-module--root--0e5d3";